export default __webpack_public_path__ + "static/media/step4-assessment-results.e6d1f786.gif";